import { ProductStateType } from "../../contexts/product-context";

export function getExpiredSubscription(data: ProductStateType) {
  if (!data?.subscriptions?.length) {
    return null;
  }

  const now = new Date();

  const candidates = data.subscriptions
    .filter((s) => (s.licenseType === "trial" || s.licenseType === "paid") && s.expirationDateTime)
    .map((s) => ({
      ...s,
      expiration: new Date(s.expirationDateTime!),
    }))
    .sort((a, b) => b.expiration.getTime() - a.expiration.getTime());

  if (!candidates.length) {
    return null;
  }

  const last = candidates[0];

  if (last.expiration.getTime() > now.getTime()) {
    return null;
  }

  return last;
}

export function getDaysOverdue(expirationDate: Date): number {
  const now = new Date();

  const diffMs = now.getTime() - expirationDate.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  return Math.max(diffDays, 0);
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function getSubscriptionExpiredViewModel(data: ProductStateType) {
  const expired = getExpiredSubscription(data);

  if (!expired) {
    return null;
  }

  const daysOverdue = getDaysOverdue(expired.expiration);

  return {
    expiredOn: formatDate(expired.expiration),
    daysOverdue,
    subscriptionType: expired.licenseType,
  };
}
